import { useQuery } from "@tanstack/react-query";
import { Paperclip, FilePdf, Image as ImageIcon } from "@phosphor-icons/react";
import api from "../lib/api";
import { Label } from "./ui/label";

function fmtSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

// Optional picker: lets the user include uploaded files alongside the generated PDF.
export function EmailAttachmentPicker({ entityType, entityId, value = [], onChange }) {
  const { data: files = [] } = useQuery({
    queryKey: ["attachments", entityType, entityId],
    queryFn: async () => (await api.get(`/attachments/${entityType}/${entityId}`)).data,
    enabled: !!entityId,
  });

  if (files.length === 0) return null;

  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);

  return (
    <div className="space-y-2">
      <Label className="overline-label flex items-center gap-1.5"><Paperclip size={13} /> Also attach uploaded files</Label>
      <div className="space-y-1.5 max-h-40 overflow-y-auto border border-border rounded-sm p-2" data-testid="email-attachment-picker">
        {files.map((f) => {
          const isImage = (f.content_type || "").startsWith("image/");
          return (
            <label key={f.id} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-secondary/40 rounded-sm px-1 py-0.5" data-testid="email-attach-option">
              <input
                type="checkbox"
                checked={value.includes(f.id)}
                onChange={() => toggle(f.id)}
                className="accent-primary h-3.5 w-3.5"
                data-testid={`email-attach-check-${f.id}`}
              />
              {isImage ? <ImageIcon size={15} className="text-primary shrink-0" /> : <FilePdf size={15} className="text-primary shrink-0" />}
              <span className="truncate flex-1" title={f.original_filename}>{f.original_filename}</span>
              <span className="text-[11px] text-muted-foreground shrink-0">{fmtSize(f.size)}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
